<template>
  <div class="main-layout">
    <div class="layout-content">
      <u-table
        :headers="headers"
        :items="items"
        :mobileBreakpoint="900"
        :showSelect="false"
        :loading="loading"
        :pagination="pagination"
        itemKey="id"
        @onChangePagination="onChangePagination"
      >
        <template v-slot:header>
          <v-row
            :justify="priorityUser === 0 ? 'space-between' : 'end'"
            align="center"
            class="header-custom-table"
          >
            <!-- // # Action Group -->
            <v-col cols="12" md="4" v-if="priorityUser === 0">
              <v-row justify="start" align="center">
                <v-col cols="12" md="6">
                  <v-btn color="primary" block dark @click="dialog = !dialog">
                    <v-icon>mdi-book-plus</v-icon>เพิ่ม{{ NameComponent }}
                  </v-btn></v-col
                >
              </v-row>
            </v-col>
            <!-- // # Search Group -->
            <v-col cols="12" md="4">
              <v-row justify="center" align="center">
                <v-col
                  ><v-text-field
                    v-model="keyword"
                    name="name"
                    outlined
                    dense
                    append-icon="mdi-magnify"
                    placeholder="ค้นหา"
                    label="ค้นหา"
                    hide-details
                    @keyup.enter="init()"
                  ></v-text-field
                ></v-col>
                <v-col cols="4">
                  <v-btn color="primary" block dark @click="init()"
                    >ค้นหา</v-btn
                  ></v-col
                >
              </v-row>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.number`]="{ item }">
          {{
            pagination.row * pagination.page -
            pagination.row +
            (items.indexOf(item) + 1)
          }}
        </template>
        <template v-slot:[`item.start_date`]="{ item }">
          {{ item.start_date | BE_DD_MM_YYYY }}
        </template>
        <template v-slot:[`item.end_date`]="{ item }">
          {{ item.end_date | BE_DD_MM_YYYY }}
        </template>
        <template v-slot:[`item.limit`]="{ item }">
          {{ item.limit == 0 ? "ไม่จำกัด" : item.limit }}
        </template>
        <template v-slot:[`item.services`]="{ item }">
          <span v-if="item.services.length == 0">-</span>
          <span v-else>
            <v-chip
              outlined
              small
              v-for="data in item.services"
              :key="data.service_id"
              color="primary"
              class="my-1"
            >
              {{ data.name }}
            </v-chip>
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                dark
                color="primary"
                @click="editItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>แก้ไขข้อมูล</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                dark
                color="error"
                @click="deleteItem(item)"
              >
                <v-icon>mdi-delete-forever</v-icon>
              </v-btn>
            </template>
            <span>ลบ</span>
          </v-tooltip>
        </template>
      </u-table>
    </div>
    <!-- // # Form AddPackead-->
    <u-card-form
      :title="formTitle"
      :subtitle="formSubTitle"
      ref="form"
      v-model="dialog"
    >
      <template v-slot:form>
        <div class="d-flex flex-wrap flex-sm-nowrap">
          <div class="mr-sm-2 box-select">
            <div>
              <span class="required">*</span><span>{{ NameComponent }}</span>
            </div>
            <v-select
              v-model="editedItem.package_id"
              :items="itemPackage"
              item-value="package_id"
              item-text="name"
              :placeholder="`เลือก${NameComponent}`"
              :rules="[Rule.noInPut]"
              required
              outlined
              dense
              :disabled="editedIndex === -1 && loading !== true ? false : true"
              @change="returnLimit(), returnLimitAll()"
            ></v-select>
          </div>
          <div class="box-select">
            <div style="padding-top: 2px">
              <span>ฟิล์มอัปโหลด/เดือน</span>
            </div>
            <v-text-field
              required
              v-model="editedItem.limitPackage"
              outlined
              dense
              :placeholder="`จำนวนฟิล์ม`"
              disabled
            ></v-text-field>
          </div>
        </div>
        <div class="d-flex flex-wrap flex-sm-nowrap">
          <div class="mr-sm-2 box-select">
            <div><span class="required">*</span><span>จำนวน(เดือน)</span></div>
            <v-select
              v-model="editedItem.duration"
              :items="itemDuration"
              :rules="[Rule.noInPut]"
              required
              outlined
              dense
              :placeholder="`จำนวนเดือน`"
              @change="changeDuration()"
            ></v-select>
          </div>
          <div class="mr-sm-2 box-select">
            <div>
              <span class="required">*</span><span>วันที่เริ่มต้น</span>
            </div>
            <!-- :return-value.sync="editedItem" -->
            <u-date-picker
              isBE
              format="DD-MM-YYYY"
              format_output="YYYY-MM-DD"
              v-model="editedItem.start_date"
              placeholder="วันที่เริ่มต้น"
              :rules="[Rule.noInPut]"
              @input="changeDuration()"
            ></u-date-picker>
            <!-- <v-dialog
              ref="dialog"
              v-model="modalDatePicker"
              :return-value.sync="editedItem.start_date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="returnFormateDate"
                  placeholder="กรุณาเลือกวันที่"
                  :rules="[Rule.noInPut]"
                  readonly
                  outlined
                  dense
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="editedItem.start_date"
                color="primary"
                no-title
                scrollable
                locale="th"
                :active-picker="$moment().format('YYYY-MM-DD')"
                :min="$moment().format('YYYY-MM-DD')"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="
                    $refs.dialog.save(editedItem.start_date), addEndDate()
                  "
                >
                  ตกลง
                </v-btn>
                <v-btn text color="primary" @click="modalDatePicker = false">
                  ยกเลิก
                </v-btn>
              </v-date-picker>
            </v-dialog> -->
          </div>
          <div class="box-select">
            <div style="padding-top: 2px">
              <span>วันที่สิ้นสุด</span>
            </div>
            <!-- <v-text-field
              required
              v-model="editedItem.end_date"
              outlined
              dense
              placeholder="วันที่สิ้นสุด"
              disabled
            ></v-text-field> -->
            <u-date-picker
              disabled
              isBE
              format="DD-MM-YYYY"
              format_output="YYYY-MM-DD"
              v-model="editedItem.end_date"
              placeholder="วันที่สิ้นสุด"
              :rules="[Rule.noInPut]"
            >
            </u-date-picker>
          </div>
        </div>
        <div>
          <span>จำนวนฟิล์มอัปโหลดทั้งหมด</span>
        </div>
        <v-checkbox
          v-model="unlimit"
          class="mb-n3 mt-0"
          label="ไม่จำกัด"
        ></v-checkbox>
        <v-text-field
          v-if="unlimit"
          value="ไม่จำกัด"
          disabled
          outlined
          dense
          :placeholder="`จำนวนฟิล์ม`"
        ></v-text-field>
        <v-text-field
          :maxlength="4"
          v-if="!unlimit"
          v-model="editedItem.limit"
          required
          :rules="[Rule.noInPut, Rule.countingNumberOnly]"
          outlined
          dense
          :placeholder="`จำนวนฟิล์ม`"
        ></v-text-field>
        <div><span class="required">*</span><span>Quotation</span></div>
        <v-text-field
          :rules="[Rule.noInPut]"
          required
          v-model="editedItem.quotation"
          outlined
          dense
          :placeholder="`กรอกQuotation`"
        ></v-text-field>
        <div><span>บันทึกข้อความ</span></div>
        <v-textarea
          outlined
          placeholder="บันทึกข้อความ"
          value=""
          v-model="editedItem.description"
        ></v-textarea>
      </template>
      <template v-slot:actions="{ valid }">
        <v-row>
          <v-col>
            <v-btn
              @click="save"
              :disabled="!valid"
              block
              color="primary"
              :loading="loadingSave"
            >
              บันทึก
            </v-btn>
          </v-col>
          <v-col
            ><v-btn block color="error" @click="close">ยกเลิก</v-btn></v-col
          >
        </v-row>
      </template>
    </u-card-form>
  </div>
</template>

<script>
export default {
  props: {
    hospital_id: {
      type: String
    },
    priorityUser: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      unlimit: false,
      modalDatePicker: false,
      NameComponent: 'แพ็คเกจ',
      editedIndex: -1,
      dialog: false,
      defaultItem: {
        package_id: '',
        start_date: '',
        duration: 1,
        time_zone: 'UTC',
        description: '',
        quotation: '',
        purchase_order: '',
        invoice: '',
        bill: '',
        receipt: '',
        end_date: '',
        limit: '',
        limitPackage: ''
      },
      editedItem: {
        package_id: '',
        start_date: '',
        duration: 1,
        time_zone: 'UTC',
        description: '',
        quotation: '',
        purchase_order: '',
        invoice: '',
        bill: '',
        receipt: '',
        end_date: '',
        limit: '',
        limitPackage: ''
      },
      loading: false,
      loadingSave: false,
      keyword: '',
      headers: [
        {
          text: 'ลำดับที่',
          value: 'number',
          align: 'center',
          sortable: false
        },
        { text: 'แพ็คเกจ', value: 'name', align: 'start', sortable: false },
        {
          text: 'วันที่เริ่มต้น',
          value: 'start_date',
          align: 'center',
          sortable: false
        },
        {
          text: 'วันที่สิ้นสุด',
          value: 'end_date',
          align: 'center',
          sortable: false
        },
        {
          text: 'ระยะเวลา(เดือน)',
          value: 'duration',
          align: 'center',
          sortable: false
        },
        {
          text: 'ทั้งหมด(จำนวนฟิล์ม)',
          value: 'limit',
          align: 'end',
          sortable: false
        },
        {
          text: 'ใช้ไป(จำนวนฟิล์ม)',
          value: 'used',
          align: 'end',
          sortable: false
        },
        {
          text: 'บริการ',
          value: 'services',
          align: 'center',
          sortable: false
        },
        {
          text: 'จัดการ',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: '100px'
        }
      ],
      items: [],
      itemDuration: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      pagination: {
        total: 0,
        page: 1,
        row: 10
      },
      itemPackage: []
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? `เพิ่ม${this.NameComponent}`
        : `แก้ไข${this.NameComponent}`
    },
    formSubTitle () {
      return this.editedIndex === -1
        ? `กรอกข้อมูลเพื่อสร้าง${this.NameComponent}`
        : `กรอกข้อมูลเพื่อแก้ไข${this.NameComponent}`
    },
    returnFormateDate: {
      set (val) {
        return val
      },
      get () {
        return this.editedItem.start_date !== ''
          ? this.$moment(this.editedItem.start_date)
            .add(543, 'year')
            .format('DD-MM-YYYY')
          : ''
      }
    }
  },
  created () {
    // this.initPackage()
    this.init()
    this.setHeaderByPriority()
  },
  watch: {
    dialog (n) {
      if (n) {
        this.initPackage()
      }
    }
  },
  methods: {
    setHeaderByPriority () {
      if (this.priorityUser !== 0) {
        this.headers = [
          {
            text: 'ลำดับที่',
            value: 'number',
            align: 'center',
            sortable: false
          },
          { text: 'แพ็คเกจ', value: 'name', align: 'start', sortable: false },
          {
            text: 'วันที่เริ่มต้น',
            value: 'start_date',
            align: 'center',
            sortable: false
          },
          {
            text: 'วันที่สิ้นสุด',
            value: 'end_date',
            align: 'center',
            sortable: false
          },
          {
            text: 'ระยะเวลา(เดือน)',
            value: 'duration',
            align: 'center',
            sortable: false
          },
          {
            text: 'ทั้งหมด(จำนวนฟิล์ม)',
            value: 'limit',
            align: 'end',
            sortable: false
          },
          {
            text: 'ใช้ไป(จำนวนฟิล์ม)',
            value: 'used',
            align: 'end',
            sortable: false
          },
          {
            text: 'บริการ',
            value: 'services',
            align: 'center',
            sortable: false
          }
        ]
      }
    },
    changeDuration () {
      this.addEndDate()
      if (this.editedIndex === -1) {
        this.returnLimitAll()
      }
    },
    save () {
      if (this.unlimit) {
        this.editedItem.limit = 0
      }
      if (this.editedIndex > -1) {
        // TODO Update Data
        this.$swal({
          allowEnterKey: false,
          title: `แก้ไข${this.NameComponent}`,
          text: `คุณต้องการแก้ไข${this.NameComponent}นี้ใช่หรือไม่`,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingSave = true

            const payload = {
              hospital_id: this.hospital_id,
              package_id: this.editedItem.id,
              start_date: this.editedItem.start_date,
              end_date: this.editedItem.end_date,
              // duration: parseInt(this.editedItem.duration),
              // time_zone: this.editedItem.time_zone,
              description: this.editedItem.description,
              quotation: this.editedItem.quotation,
              purchase_order: this.editedItem.purchase_order,
              invoice: this.editedItem.invoice,
              bill: this.editedItem.bill,
              receipt: this.editedItem.receipt,
              limit: parseInt(this.editedItem.limit)
            }
            const res = await this.updateHospitalPackage(payload)
            this.loadingSave = false
            if (res.status) {
              this.init()
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: `แก้ไข${this.NameComponent}สำเร็จ`,
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        })
      } else {
        // TODO Create Data
        this.$swal({
          allowEnterKey: false,
          title: `เพิ่ม${this.NameComponent}`,
          text: `คุณต้องการเพิ่ม${this.NameComponent}นี้ใช่หรือไม่`,
          icon: 'info',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.loadingSave = true
            const payload = {
              ...this.editedItem,
              ...{
                hospital_id: this.hospital_id
              }
            }
            const res = await this.createHospitalPackage(payload)
            this.loadingSave = false
            if (res.status) {
              this.init()
              this.$swal({
                allowEnterKey: false,
                title: 'สำเร็จ',
                text: `แก้ไข${this.NameComponent}สำเร็จ`,
                icon: 'success',
                showConfirmButton: false,
                showCancelButton: false,
                timer: 3000
              })
              this.close()
            } else {
              this.antmessage.error(res.message)
            }
          }
        })
      }
    },
    async init () {
      // init package for selecter
      this.initPackage()

      this.loading = true
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      const payload = {
        page: this.pagination.page,
        row: this.pagination.row,
        hospital_id: this.hospital_id,
        keyword: this.keyword
      }
      const res = await this.getHospitalPackageForTable(payload)
      this.loading = false
      if (res.status) {
        this.items = res.data.data
        this.pagination = res.data.pagination
      } else {
        this.antmessage.error(res.message)
      }
    },
    async initPackage () {
      this.loading = true
      const res = await this.getPackageForDropdown()
      this.loading = false
      if (res.status) {
        // TODO when get data success
        this.itemPackage = res.data
      } else {
        // TODO when get data fail
        this.antmessage.error(res.message)
      }
    },
    close () {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },
    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      // this.editedItem.duration = this.editedItem.duration
      // this.returnLimitAll()
      // this.editedItem.end_date = this.$moment(this.editedItem.end_date)
      //   .add(543, 'year')
      //   .format('DD-MM-YYYY')
      this.returnLimit()
      if (this.editedItem.limit === 0) {
        this.unlimit = true
        this.editedItem.limit = ''
        this.editedItem.limitPackage = 'ไม่จำกัด'
      }
      this.dialog = true
    },
    onChangePagination (val) {
      this.pagination.page = val.page
      this.pagination.row = val.row
      this.init()
    },
    deleteItem (item) {
      this.$swal({
        allowEnterKey: false,
        title: `ลบ${this.NameComponent}`,
        text: `คุณต้องการลบ${this.NameComponent}นี้ใช่หรือไม่`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง'
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.antmessage.loading('กำลังดำเนินการ', 0)
          const payload = {
            hospital_id: this.hospital_id,
            id: item.id
          }
          const res = await this.deleteHospitalPackage(payload)
          this.antmessage.destroy()
          if (res.status) {
            this.init()
            this.$swal({
              allowEnterKey: false,
              title: 'สำเร็จ',
              text: `ลบ${this.NameComponent}สำเร็จ`,
              icon: 'success',
              showConfirmButton: false,
              showCancelButton: false,
              timer: 3000
            })
          } else {
            this.antmessage.error(res.message)
          }
        }
      })
    },
    returnLimit () {
      const data = this.itemPackage.filter(
        (i) => i.package_id === this.editedItem.package_id
      )
      this.editedItem.limitPackage = String(data[0].limit)
      if (this.editedItem.limitPackage === '0') {
        this.editedItem.limitPackage = 'ไม่จำกัด'
      }
    },
    returnLimitAll () {
      if (
        this.editedItem.limitPackage !== null &&
        this.editedItem.limitPackage !== '' &&
        this.editedItem.duration !== null &&
        this.editedItem.duration !== ''
      ) {
        console.log(
          'this.editedItem.limitPackage',
          this.editedItem.limitPackage
        )
        if (this.editedItem.limitPackage === 'ไม่จำกัด') {
          this.editedItem.limit = ''
          this.unlimit = true
        } else {
          this.editedItem.limit =
            this.editedItem.limitPackage * this.editedItem.duration
        }
      }
    },
    addEndDate () {
      if (
        this.editedItem.duration !== null &&
        this.editedItem.duration !== '' &&
        this.editedItem.start_date !== null &&
        this.editedItem.start_date !== ''
      ) {
        this.editedItem.end_date = this.$moment(this.editedItem.start_date)
          .add(this.editedItem.duration, 'month')
          .format('YYYY-MM-DD')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  height: 100%;
}
.layout-content {
  height: 100%;
  padding: 0;
  margin: 0;
}
.header-custom-table .header-custom-search {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}
.header-custom-table .header-custom-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  height: 100%;
  min-height: 70px;
}
@media screen and (max-width: 600px) {
  .box-select {
    width: 100%;
  }
}
</style>
